import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { getSelectedStore } from 'x/redux/selectors'

import { TouchableOpacity, View } from 'react-native'

import p from 'x/config/platform-specific'
import CONS from 'x/config/constants'
import * as util from 'x/utils/util'
import * as api from 'x/utils/api'
import { COLORS, S } from 'x/config/styles'
import {
  ICrmChannelDetailViewProps,
  ICrmChannelDetailViewState,
  ISearchProductItem,
  IBarcodeScannerOutput,
  ISearchProductVariantListViewNavParams,
  IXSegmentOption,
  ISearchInventoryProductsParams,
  IQtyAdjustReason,
  ICrmChannel,
} from 'x/types'

// import BackIcon from 'xui/components/BackIcon'
import VStack from 'xui/components/VStack'
import XText from 'xui/components/XText'
import XContent from 'xui/components/XContent'
import XContainer from 'xui/components/XContainer'
import XCustomHeader from 'xui/components/XCustomHeader'
import * as NavActions from 'x/utils/navigation'
import HStack from 'xui/components/HStack'
import XImage from 'xui/components/XImage'
import XIconButton from 'xui/components/XIconButton'
import XIcon from 'xui/components/XIcon'
import CrmLogo from 'xui/components/CrmLogo'
import XCard from 'xui/components/XCard'
import XSpinner from 'xui/components/XSpinner'
import XInput from 'xui/components/XInput'
import time from 'x/utils/time'

class CrmChannelDetailView extends React.Component<ICrmChannelDetailViewProps, ICrmChannelDetailViewState> {
  static displayName = 'CrmChannelDetailView'

  _inProcess?: boolean

  constructor(props: ICrmChannelDetailViewProps) {
    super(props)
    this.state = {
      isInitialized: false,
      isRefreshing: false,
      crmChannelDetail: null,

      isEditingName: false,
      editingName: '',
    }
  }

  async componentDidMount() {
    await this._initializeView()
    await util.delay(200)
    await this._fetchCrmChannelDetail()
  }

  _initializeView = async () => {
    await util.setStatePromise(this, { isInitialized: false, products: [], selectedReason: null })
    // Init activeStatesMap
    const newState: Partial<ICrmChannelDetailViewState> = {}
    // get ready to render
    newState.isInitialized = true

    await util.setStatePromise(this, newState)
  }

  _fetchCrmChannelDetail = async () => {
    if (this._inProcess) {
      return
    }
    this._inProcess = true
    await util.setStatePromise(this, { isRefreshing: true })

    const storeId = util.getNavParam(this.props, 'store_id')
    const crmChannelId = util.getNavParam(this.props, 'crm_channel_id')
    try {
      const res = await api.getCrmChannelDetail({
        store_id: storeId,
        crm_channel_id: crmChannelId,
      })

      if (res && res.crm_channel) {
        await util.setStatePromise(this, { crmChannelDetail: res.crm_channel, editingName: res.crm_channel.name })
      }
    } catch (err) {
      console.log('CrmChannelDetailView::_fetchCrmChannelDetail:: err => ', err)
    }

    await util.setStatePromise(this, { isRefreshing: false })
    this._inProcess = false
  }

  _goBack = () => {
    util.navGoBack(this.props)
  }

  _renderCustomHeader = () => {
    return <XCustomHeader title={p.op.t('crm.channelDetailView.title')} headerLeftProps={{ backIcon: true, onPressItem: this._goBack }} />
  }

  // navToCrmChannelDetailView = (crmChannel: ICrmChannel) => {
  //   NavActions.navToCrmChannelDetailView(this.props.navigation, {
  //     store_id: crmChannel.store_id,
  //     crm_channel_id: crmChannel.id,
  //   })
  // }

  _onPressEditCrmChannelName = () => {
    console.log('Edit CRM Channel Name')
    const { crmChannelDetail } = this.state
    this.setState({ isEditingName: true, editingName: crmChannelDetail?.name })
  }

  _onPressSaveCrmChannelName = async () => {
    if (this._inProcess) {
      return
    }
    this._inProcess = true

    // console.log('Save CRM Channel Name')
    const { editingName } = this.state
    const storeId = util.getNavParam(this.props, 'store_id')
    const crmChannelId = util.getNavParam(this.props, 'crm_channel_id')

    try {
      const res = await api.updateCrmChannel({
        store_id: storeId,
        crm_channel_id: crmChannelId,
        name: editingName,
      })

      if (res && res.crm_channel) {
        await util.setStatePromise(this, {
          crmChannelDetail: res.crm_channel,
          isEditingName: false,
          editingName: res.crm_channel.name,
        })

        const onCrmChannelUpdated = util.getNavParam(this.props, 'onCrmChannelUpdated')
        if (onCrmChannelUpdated) {
          onCrmChannelUpdated(res.crm_channel)
        }
      }
    } catch (err) {
      console.log('CrmChannelDetailView::_onPressSaveCrmChannelName:: err => ', err)
    }

    this._inProcess = false
  }

  _renderContent = () => {
    const { isInitialized, isRefreshing, crmChannelDetail, isEditingName, editingName } = this.state
    if (!isInitialized) {
      return null
    }

    if (isRefreshing) {
      return (
        <VStack w='full' p='2'>
          <XSpinner />
        </VStack>
      )
    }

    return (
      <VStack w='full' px='4' py='2' bg='white' space='2'>
        <HStack w='full' alignItems='center' space='1'>
          <XText variant='inactive'>{p.op.t('crm.channelDetailView.name')}:</XText>

          {isEditingName ? (
            <XInput
              textAlign='right'
              flex={1}
              value={editingName}
              editable={isEditingName}
              onChangeText={(text) => this.setState({ editingName: text })}
            />
          ) : (
            <XText flex={1} textAlign='right'>
              {crmChannelDetail?.name}
            </XText>
          )}

          {isEditingName ? null : (
            <HStack w='34px' alignItems='center' justifyContent='flex-end'>
              <TouchableOpacity onPress={this._onPressEditCrmChannelName}>
                <XIcon name='edit' family='FontAwesome' />
              </TouchableOpacity>
            </HStack>
          )}
        </HStack>
        {isEditingName ? (
          <HStack w='full' alignItems='center' justifyContent='flex-end' space='1'>
            <TouchableOpacity onPress={this._onPressSaveCrmChannelName}>
              <HStack
                w='100px'
                h='34px'
                borderWidth='1'
                borderColor='primary.500'
                borderRadius='50px'
                bg='primary.500'
                space='2'
                alignItems='center'
                justifyContent='center'
              >
                <XIcon name='save' family='FontAwesome' variant='activeDark' />

                <XText variant='activeDark'>{p.op.t('save')}</XText>
              </HStack>
            </TouchableOpacity>

            <TouchableOpacity onPress={() => this.setState({ isEditingName: false })}>
              <HStack
                w='100px'
                h='34px'
                borderWidth='1'
                borderColor='gray.500'
                borderRadius='50px'
                bg='gray.100'
                space='2'
                alignItems='center'
                justifyContent='center'
              >
                <XIcon name='cancel' family='MaterialCommunityIcons' variant='active' />

                <XText variant='active'>{p.op.t('cancel')}</XText>
              </HStack>
            </TouchableOpacity>
          </HStack>
        ) : null}

        <HStack w='full' alignItems='center' space='1'>
          <XText variant='inactive'>{p.op.t('crm.channelDetailView.crm_system_id')} </XText>

          <HStack flex={1} justifyContent='flex-end' space='1.5'>
            <CrmLogo crmSystemId={crmChannelDetail?.crm_system_id || 0} />

            <XText textAlign='right'>{util.getCrmSystemNameById(crmChannelDetail?.crm_system_id || 0)}</XText>
          </HStack>
        </HStack>

        {/* <HStack w='full' alignItems='center' space='1'>
          <XText variant='inactive'>crm_system_account_id: </XText>

          <XText flex={1} textAlign='right'>
            {crmChannelDetail?.crm_system_account_id}
          </XText>
        </HStack> */}

        <HStack w='full' alignItems='center' space='1'>
          <XText variant='inactive'>{p.op.t('crm.channelDetailView.is_active')}: </XText>

          <XText flex={1} textAlign='right'>
            {crmChannelDetail?.is_active ? p.op.t('crm.channelDetailView.active') : p.op.t('crm.channelDetailView.inactive')}
          </XText>
        </HStack>

        <HStack w='full' alignItems='center' space='1'>
          <XText variant='inactive'>{p.op.t('crm.channelDetailView.created_at')}: </XText>

          <XText flex={1} textAlign='right'>
            {/* {crmChannelDetail?.created_at} */}
            {time.convertServerDateTimeToReadableDateTimeText(crmChannelDetail?.created_at)}
          </XText>
        </HStack>
      </VStack>
    )
  }

  _onPressDeleteCrmChannel = async () => {
    if (this._inProcess) {
      return
    }
    this._inProcess = true

    const storeId = util.getNavParam(this.props, 'store_id')
    const crmChannelId = util.getNavParam(this.props, 'crm_channel_id')

    const isUserConfirmed = await p.op.isUserConfirm(
      p.op.t('crm.channelDetailView.confirmDeleteCrmChannelTitle'),
      p.op.t('crm.channelDetailView.confirmDeleteCrmChannelMessage')
    )

    if (!isUserConfirmed) {
      this._inProcess = false
      return
    }

    try {
      const ok = await api.deleteCrmChannel({
        store_id: storeId,
        crm_channel_id: crmChannelId,
      })

      if (ok) {
        const onCrmChannelDeleted = util.getNavParam(this.props, 'onCrmChannelDeleted')
        if (onCrmChannelDeleted) {
          onCrmChannelDeleted(crmChannelId)
        }

        // go back
        this._goBack()
      }
    } catch (err) {
      console.log('CrmChannelDetailView::_onPressDeleteCrmChannel:: err => ', err)
    }

    this._inProcess = false
  }

  _renderDeleteCrmChannelButton = () => {
    const { isEditingName, isInitialized, isRefreshing } = this.state
    if (isEditingName || !isInitialized || isRefreshing) {
      return null
    }

    return (
      <HStack w='full' py='8' px='2' alignItems='center' justifyContent='center'>
        <TouchableOpacity onPress={this._onPressDeleteCrmChannel}>
          <HStack
            w='200px'
            h='34px'
            borderWidth='1'
            borderColor='red.500'
            borderRadius='50px'
            bg='gray.100'
            space='2'
            alignItems='center'
            justifyContent='center'
          >
            <XIcon name='delete' family='MaterialIcons' variant='danger' />

            <XText variant='danger'>{p.op.t('crm.channelDetailView.deleteCrmChannelBtn')}</XText>
          </HStack>
        </TouchableOpacity>
      </HStack>
    )
  }

  render() {
    return (
      <XContainer>
        {this._renderCustomHeader()}
        <XContent>
          {this._renderContent()}
          {this._renderDeleteCrmChannelButton()}
        </XContent>
      </XContainer>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
  }),
  (dispatch) => ({
    dispatch,
  })
)(CrmChannelDetailView)
